module.exports = __webpack_public_path__ + "img/newchris-19.b748d6b9.jpg";